import { Dispatch } from "redux";
import { SecuritySettingsData } from "../../../models/securitySettingsData";
import { securityPoliciesService } from "../../../api/index";
import {
  SECURITY_SETTINGS_FAILURE,
  SECURITY_SETTINGS_REQUEST,
  SECURITY_SETTINGS_SUCCESS,
  SecuritySettingsActionTypes,
  SecuritySettingsRequestAction,
  SecuritySettingsSuccessAction,
  SecuritySettingsFailureAction,
} from "./types";

/**
 * Async action to fetch security settings.
 *
 * Dispatches a request action, then attempts to fetch security settings from the API.
 * If successful, dispatches success action with data.
 * If failed, dispatches failure action.
 *
 * @returns A thunk action for Redux.
 */
export const getSecuritySettings = () => {
  return async (dispatch: Dispatch<SecuritySettingsActionTypes>) => {
    dispatch(securitySettingsRequest());
    securityPoliciesService
      .getSecuritySettings()
      .then((response: SecuritySettingsData) => {
        dispatch(securitySettingsSuccess(response));
      })
      .catch(() => {
        dispatch(securitySettingsFailure());
      });
  };
};

/**
 * Action creator for successfully fetched security settings.
 *
 * @param data - Array of security settings objects.
 * @returns Action with type `SECURITY_SETTINGS_SUCCESS` and payload.
 */
export function securitySettingsSuccess(
  data: SecuritySettingsData
): SecuritySettingsSuccessAction {
  return {
    type: SECURITY_SETTINGS_SUCCESS,
    data,
  };
}

/**
 * Action creator for initiating the security settings request.
 *
 * @returns Action with type `SECURITY_SETTINGS_REQUEST`.
 */
export function securitySettingsRequest(): SecuritySettingsRequestAction {
  return {
    type: SECURITY_SETTINGS_REQUEST,
  };
}

/**
 * Action creator for failed security settings request.
 *
 * @returns Action with type `SECURITY_SETTINGS_FAILURE`.
 */
export function securitySettingsFailure(): SecuritySettingsFailureAction {
  return {
    type: SECURITY_SETTINGS_FAILURE,
  };
}
